import { MapTo } from '@adobe/aem-react-editable-components';
import Tiles, { TilesEditConfig } from './Tiles';

export default MapTo('cob-corp-acquisition/components/creditonebank/tiles')(Tiles, TilesEditConfig);